/**
 * @generated SignedSource<<6545ac1e28c315dfff925307fd438ff1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type courseLesson_lesson$data = {
  readonly attachments: ReadonlyArray<{
    readonly id: string;
    readonly originalName: string;
    readonly signedUrl: string;
    readonly size: string | null | undefined;
  }>;
  readonly completed: boolean;
  readonly course: {
    readonly completed: boolean;
    readonly progress: number;
    readonly slug: string;
    readonly " $fragmentSpreads": FragmentRefs<"certificateEmitDialogFragment">;
  };
  readonly description: any | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly nextClass: {
    readonly canAccess: boolean;
    readonly slug: string;
    readonly url: string;
  } | null | undefined;
  readonly previousClass: {
    readonly canAccess: boolean;
    readonly slug: string;
    readonly url: string;
  } | null | undefined;
  readonly section: {
    readonly id: string;
  };
  readonly video: {
    readonly __typename: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"courseLessonComments_lesson" | "courseVideo">;
  readonly " $fragmentType": "courseLesson_lesson";
};
export type courseLesson_lesson$key = {
  readonly " $data"?: courseLesson_lesson$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseLesson_lesson">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseLesson_lesson",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseSection",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "progress",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "certificateEmitDialogFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "courseVideo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nextClass",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "previousClass",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signedUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "courseLessonComments_lesson"
    }
  ],
  "type": "CourseContent",
  "abstractKey": null
};
})();

(node as any).hash = "282d7b7727f381d0b911d695ac3eeb29";

export default node;
